var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.726,
    height: 18,
    viewBox: "0 0 13.726 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34189",
    "data-name": "Group 34189",
    transform: "translate(-14.505 -625.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(14.505 627.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22860",
    "data-name": "Path 22860",
    d: "M14.49,12.127a3.564,3.564,0,1,0-3.564-3.564A3.564,3.564,0,0,0,14.49,12.127Zm0-5.685a2.121,2.121,0,1,1-2.121,2.121A2.121,2.121,0,0,1,14.49,6.442Z",
    transform: "translate(-8.478 -4.999)",
    fill: "#e24848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22863",
    "data-name": "Path 22863",
    d: "M16.732,19.375a7.284,7.284,0,0,0-4.924-2.768,5.863,5.863,0,0,0-4.924,2.768A6.228,6.228,0,0,0,5.7,23.341a.721.721,0,0,0,1.443,0c0-2.918,2.092-5.291,4.665-5.291s4.665,2.373,4.665,5.291a.721.721,0,1,0,1.443,0A7.371,7.371,0,0,0,16.732,19.375Z",
    transform: "translate(-5.7 -8.234)",
    fill: "#e24848"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30952",
    "data-name": "Group 30952",
    transform: "translate(26.72 625.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34171",
    "data-name": "Group 34171",
    transform: "translate(0.03 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34167",
    "data-name": "Group 34167",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40314",
    "data-name": "Path 40314",
    d: "M234.3,173c-.4,0-.721.217-.721.6,0,1.175.138,2.865.138,4.04,0,.306.267.435.583.435.237,0,.573-.128.573-.435,0-1.175.138-2.865.138-4.04A.635.635,0,0,0,234.3,173Z",
    transform: "translate(-233.578 -173.005)",
    fill: "#e24848"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34172",
    "data-name": "Group 34172",
    transform: "translate(0 5.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34169",
    "data-name": "Group 34169",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40315",
    "data-name": "Path 40315",
    d: "M233.412,353.306a.761.761,0,0,0,0,1.521.761.761,0,0,0,0-1.521Z",
    transform: "translate(-232.651 -353.306)",
    fill: "#e24848"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleReport);
export default __webpack_public_path__ + "static/media/single_report.c45b7cd738a91bd8b19f3781f9b5de72.svg";
export { ForwardRef as ReactComponent };